import PromptDialog from "./PromptDialog";

export default PromptDialog.create({});



// WEBPACK FOOTER //
// ./src/components/common/promptService/index.js